import { Skeleton } from "antd";

export default function RichTextLoading() {
  return (
    <div className="flex flex-col gap-3">
      <Skeleton active title={false} paragraph={{ rows: 1, width: "60%" }} />
      <Skeleton active title={false} paragraph={{ rows: 2, width: "100%" }} />
      <Skeleton active title={false} paragraph={{ rows: 1, width: "80%" }} />
      <Skeleton active title={false} paragraph={{ rows: 2, width: "100%" }} />
      <Skeleton active title={false} paragraph={{ rows: 1, width: "50%" }} />
    </div>
  );
}
